// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "select[data-v-b00e03dc]{background-color:#e0e0e0;border-width:0;display:inline-block;width:auto;padding:1px 5px;height:auto;border-radius:8px;cursor:pointer;text-align:center;-moz-text-align-last:center;text-align-last:center;appearance:none;-moz-appearance:none;-webkit-appearance:none}select[data-v-b00e03dc]::-ms-expand{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
